import styled from 'styled-components'
import { mobileL, mobileS, tablet } from '../../../utils/mediaQueries'

const ApplicationsWrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  max-height: calc(100vh - 10vh);
  overflow-y: scroll;
  padding: 50px;
  flex-wrap: wrap;
  justify-content: center;

  ${tablet({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    gap: '16px',
    maxHeight: 'calc(100vh - 15vh)',
    overflowY: 'scroll',
    margin: '0',
    paddingTop: '20px',
    paddingLeft: '20px',
    paddingRight: '20px',
    flexWrap: 'nowrap',
  })};

  ${mobileS({
    maxHeight: 'calc(100vh - 20vh)',
  })}

  .main-tite {
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    color: #081339;
    align-self: flex-start;
    margin-left: 5%;
  }

  .nextui-table {
    padding: 0;
  }
  .nextui-table-header-row th {
    background-color: #ffede8;
    color: #6e7ba7;
    font-weight: 400;
    font-size: 14px;
    padding: 1.5rem;
  }
  .nextui-table-container {
    background-color: white;
    max-width: 1180px;
    margin: 2rem auto;
    border: 1px solid #f3f3f3;
    border-radius: 12px;

    th {
      border-radius: 0;
    }
    td {
      padding: 1.5rem;
      color: #27345e;
      font-size: 13px;
    }

    ${mobileL({
      margin: '0rem 0',
    })};
  }
  .apply-btn {
    text-decoration: underline;
    cursor: pointer;
    color: #faad14;
  }
  .titre {
    display: flex;
    justify-content: flex-start;
    padding: 20px;
  }
  .card {
    margin-bottom: 8px;
    padding: 15px 30px;
  }
  .buttons-card {
    display: flex;
    justify-content: flex-end;
    align-self: center;
  }
  .job-title {
    text-align: left;
    color: black;
  }
`
export default ApplicationsWrapper
